import { render, staticRenderFns } from "./PageTableItem.vue?vue&type=template&id=590cb336&scoped=true"
import script from "./PageTableItem.vue?vue&type=script&lang=js"
export * from "./PageTableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590cb336",
  null
  
)

/* custom blocks */
import block0 from "./PageTableItem.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports